<script>
  import { closeModal } from "svelte-modals";
  import { t } from '../../services/translation/translationService.js';
  import { onMount } from "svelte";

  export let message = 'Are you sure you want to delete this search thread?';
  export let confirmButtonText = $t('confirmGenericText');
  export let cancelButtonText = $t('cancelGenericText');
  export let onCancel
  export let onConfirm
  let confirmButton;

  function handleAction(action) {
    if (action === 'confirm') {
      onConfirm(true);
    }
    if (action === 'cancel') {
      onCancel(true);
    }
    closeModal()
  }

  function handleKeydown(event) {
    if (event.key === 'Enter') {
      onConfirm(true)
    }
    if (event.key === 'Escape') {
      onCancel(true)
    }
  }

  onMount(() => {
    confirmButton.focus(); // Auto-focus when the modal opens
  });
</script>

<div class="modal" role="dialog">
  <div
    class="modal-content"
  >
    <p>{message}</p>
    <div class="button-container">
      <button bind:this={confirmButton} class="confirm-button" on:click={()=>handleAction('confirm')}
              on:keydown={handleKeydown}>
        {confirmButtonText}
      </button>
      <button class="cancel-button" on:click={()=>handleAction('cancel')}>
        {cancelButtonText}
      </button>
    </div>
  </div>
</div>

<style>
  .button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  button {
    margin: 0;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: #f0f0f0;
    transition: background-color 0.3s;
  }

  button:hover {
    background-color: #e0e0e0;
  }

  .confirm-button {
    color: #ffffff;
    background-color: #003476;
  }

  .confirm-button:hover {
    background-color: #002357;
  }

  button:focus {
    outline: 2px solid black;
  }
</style>